var map = {
	"./14-home_default_editor.jpg": "c82e",
	"./acier-sidebar.jpg": "f09a",
	"./acier.jpg": "d25e",
	"./aluminium-sidebar.jpg": "2e63",
	"./aluminium.jpg": "f496",
	"./bois-massif-sidebar.jpg": "586c",
	"./bois.jpg": "72cc",
	"./inox-sidebar.jpg": "0fe2",
	"./inox.jpg": "a1d5",
	"./massif-sidebar.jpg": "065c",
	"./massif.jpg": "954e",
	"./medium-sidebar.jpg": "a1dc",
	"./medium.jpg": "017e",
	"./metal.jpg": "cecf",
	"./stratifie-compact.jpg": "f76d",
	"./stratifie-sidebar.jpg": "33ba",
	"./stratifie.jpg": "d13d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d1e";